<template>
  <div class="card-header">
    <span>{{ submittedBooks.department.deptCode }} {{ submittedBooks.course.sisCourseId.substring(0, 8) }} |
      {{ submittedBooks.course.name }} </span>

    <div class="float-end">
      <span class="v-a-super">
        Submitted
      </span>
      <span class="material-icons text-primary" title="Submitted">check_circle</span>
    </div>
  </div>
  <div class="course-card">
    <CourseCards :adoptions="submittedBooks.adoptions" :flag='0' @updateAdoption="updateAdoption($event)"
      @removeAdoption="removeAdoption($event)" />
  </div>
  <div class="card-footer">
    <ul class="nav nav-pills" id="pills-tab" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="#pills-home-tab" data-bs-toggle="pill"
          :data-bs-target="'#pills-add' + submittedBooks.course.sisCourseId" type="button" role="tab"
          aria-controls="pills-home" aria-selected="true">
          Add Course Materials
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
          :data-bs-target="'#pills-remove' + submittedBooks.course.sisCourseId" type="button" role="tab"
          aria-controls="pills-profile" aria-selected="false">
          Delete Adoption
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
          :data-bs-target="'#pills-suggest' + submittedBooks.course.sisCourseId" type="button" role="tab"
          aria-controls="pills-openSource" aria-selected="false">
          Suggest Additional Materials
        </button>
      </li>

    </ul>
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade text-primary" :id="'pills-add' + submittedBooks.course.sisCourseId" role="tabpanel"
        aria-labelledby="pills-home-tab">
        <div class="card suggestion-card">
          <label class="form-control-label" for="form-control-search">
            <p><b>Search Materials</b></p>
          </label>
          <div>
            <AdSearch :coursedetails="submittedBooks.adoptions[0].sectionId" @useTheBook="useTheBook($event)"
              @saveBookAdoption="saveNewBook" />
          </div>
        </div>
      </div>
      <div class="tab-pane fade" :id="'pills-remove' + submittedBooks.course.sisCourseId" role="tabpanel"
        aria-labelledby="pills-profile-tab">
        <div class="card suggestion-card">
          <p><b>Remove All Materials</b></p>
          <p>Will you be using any materials for this course?</p>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault3" :value=false
              v-model="radio_checked" />
            <label class="form-check-label" for="flexRadioDefault3">
              Yes!! I will choose them later
            </label>
          </div>

          <div class="form-check">
            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault4" :value=true
              v-model="radio_checked" />
            <label class="form-check-label" for="flexRadioDefault4">
              No materials required
            </label>
            <div class="notes-card col-sm-8" v-if=radio_checked>
              <form>
                <div class="mb-3">
                  <label for="exampleInputNotes" class="form-label"><b>Notes:</b><i>(Optional)</i></label>
                  <VueEditor v-model="notes" :editorToolbar="customToolbar"></VueEditor>
                </div>
              </form>
            </div>
          </div>
          <div class="gap-2 d-md-flex justify-content-md-end">
            <button @click="removeAdoptionbySection(submittedBooks.adoptions[0].sectionId, radio_checked, notes)"
              type="button float-right" class="btn btn-outline-danger me-2">
              <span class="material-icons-outlined btn-icon"> delete </span>
              Remove from course
            </button>
          </div>
        </div>
      </div>
      <div class="tab-pane fade text-primary" :id="'pills-suggest' + submittedBooks.course.sisCourseId" role="tabpanel"
        aria-labelledby="pills-home-tab">
        <div class="row notes-card">
          <div class="col-sm-8">
            <form>
              <label class="fw-bold">NOTES:&nbsp;</label>
              <vue-editor class="bg-white" v-model="notes" :editorToolbar="customToolbar"></vue-editor>

            </form>
          </div>
          <div class="col-sm-4 btn-notes">
            <button type="button" class="btn btn-primary me-2"
              @click="removeAdoptionbySection(submittedBooks.adoptions[0].sectionId, true, notes)">
              <span class="material-icons-outlined btn-icon"> check_circle </span>
              Update Notes
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import CourseCards from '../Faculty/CourseCards.vue';
import AdSearch from '../Faculty/SearchComponent.vue';
import { VueEditor } from "vue3-editor";
export default {
  name: "SubmittedCard",
  props: ['_submittedBooks'],
  methods: {
    removeAdoptionbySection(section, radio_selection,notes) {
      console.log(radio_selection,"radio")
      if(radio_selection===''){
        this.$store.dispatch('showToaster', { message: "Please select one option!", status: false });
      }
      else{
      var con = { "sectionId": section, "isNoMaterialsRequired": radio_selection, "notes":notes }
      this.$store.dispatch("removeAdoptionbySection", con).then(() => {
        this.getAdoptions();
      })
    }
    },
    updateAdoption(adoption) {
      console.log(adoption, "adoption")
      if (!adoption.suggestion) {
        this.$store.dispatch('showToaster', { message: "Please select suggestion type", status: false });
        return;
      }
      let obj = {
        sectionId: adoption.sectionId,
        adoptions: [{ id: adoption.id, notes: adoption.notes, suggestion: parseInt(adoption.suggestion) }]
      }
      this.$store.dispatch("upsertAdoption", obj).then(() => {
        let _ = require('lodash');
        this.initAdoptions = _.cloneDeep(this.adoptions);
      })
    },
    useTheBook(adoption) {
      this.$store.dispatch("usePreviousBook", adoption).then(() => {
        this.getAdoptions();
      });
    },
    removeAdoption(adoptionId) {
      this.$store.dispatch("removeAdoption", adoptionId).then(() => {
        this.getAdoptions();
      });
    },
    getAdoptions() {
      this.$emit('getCourseBooks');
    },
    saveNewBook() {
      this.getAdoptions();
    }
  },
  data() {
    return {
      adoptionsbyinstructor: [],
      radio_checked: '',
      submittedBooks: this._submittedBooks,
      notes: '',
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{
          align: ""
        },
        {
          align: "center"
        },
        {
          align: "right"
        },
        {
          align: "justify"
        }],
        ["bold", "italic", "underline", "link"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }]
      ],
    };
  },
  watch: {
    _submittedBooks() {
      this.submittedBooks = this._submittedBooks;
    }
  },
  components: {
    CourseCards,
    AdSearch,
    VueEditor
  },
  mounted() {
  }
};
</script>

<style scoped>
.suggestion-card {
  margin: 10px 0px 15px 0px;
  padding: 15px;
}

.notes-card {
  margin: 10px 0px 15px 0px;
  padding: 15px;
}

.float-right {
  float: right;
}

.card-header,
.card-footer {
  background-color: #f1f9f6d6;
}

.btn-notes {
  vertical-align: revert;
  display: flex;
  align-items: end;
  justify-content: end
}
.v-a-super{
  vertical-align: super;
}
</style>